import { UseQueryOptions } from 'react-query';
import { useAppQuery } from '.';
import { API_ROUTES } from '@/constants/api-routes';
import queryKeys from '@/constants/queryKeys';
import { IMondayContext } from '@/types/response/monday/context';
import { IResolveEnvelopeResponse } from '@/types/response/envelope';

export const useResolveEnvelopeQuery = (
  context?: IMondayContext,
  options?: UseQueryOptions<IResolveEnvelopeResponse>,
) => {
  return useAppQuery<IResolveEnvelopeResponse>({
    routeName: API_ROUTES.RESOLVE_ENVELOPE,
    queryKey: [queryKeys.RESOLVE_ENVELOPE, context?.instanceId, context?.boardId],
    method: 'POST',
    requestConfig: {
      data: {
        instanceId: context?.instanceId,
        boardId: context?.boardId,
      },
      routeParams: {},
    },
    options: {
      enabled: !!context,
      refetchOnWindowFocus: false,
      ...options,
    },
  });
};
